import React from "react";

const AboutUs = () => {
  return (
    <div
      className="container-fluid py-5"
       data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
      style={{
        backgroundColor: "#ffffff",
        borderRadius: "10px",
        boxShadow: "0px 0px 12px rgba(0, 0, 0, 0.08)",
      }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6 mb-4 mb-md-0">
            <div
              style={{
                overflow: "hidden",
                borderRadius: "10px",
                maxHeight: "400px",
              }}
            >
              <img
                src="../assets/images/IT_Consulting_Images/about-image.jpg"
                alt="Our Vision"
                className="img-fluid"
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                }}
              />
            </div>
          </div>
          <div className="col-md-6">
            <h2 className="fw-bold mb-4 text-danger" style={{ fontSize: "3rem" }}>
              About Us
            </h2>
            <p
              style={{
                fontSize: "1.1rem",
                color: "#555555",
                lineHeight: "1.6",
              }}
            >
              At Starparth Technologies , we are passionate about empowering businesses
              through transformative IT consulting services. With years of experience
              and a deep understanding of emerging technologies, we help organizations
              optimize their processes, enhance customer engagement, and achieve
              sustainable growth.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};


export default AboutUs;